import {NgModule} from '@angular/core';
import {MaterialModule} from '../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {LoginComponent} from './login/login.component';
import {AuthRouterModule} from './auth-route.module';
import {
  GoogleLoginProvider,
  GoogleSigninButtonModule,
  SocialAuthServiceConfig,
  SocialLoginModule
} from "@abacritt/angularx-social-login";
import {ToastModule} from "primeng/toast";

@NgModule({
  declarations: [LoginComponent],
  imports: [
    AuthRouterModule,
    MaterialModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    ToastModule,
    FormsModule,
    SocialLoginModule,
    GoogleSigninButtonModule],
  exports: [AuthRouterModule],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('356132165092-7po9nefkdsiam886ca04bh3rqs3brshk.apps.googleusercontent.com')
          },

        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }
  ]
})
export class AuthModule {
}
